module.exports = __webpack_public_path__ + "img/329110405.635d6c66.svg";